import { AbstractControl, ValidatorFn } from '@angular/forms';

export function italianFiscalCodeValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;
    const cfRegex = /^[A-Z]{6}[0-9]{2}[A-EHLMPR-T][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
    if (!cfRegex.test(value.toUpperCase())) {
      return { fiscalCodePattern: true };
    }
    return null;
  };
}
export function foreignFiscalCodeValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;
    const cfRegex = /^[A-Z0-9]{2,28}$/;
    if (!cfRegex.test(value.toUpperCase())) {
      return { fiscalCodePattern: true };
    }
    return null;
  };
}
